export const Validate = () => {
  return (
    <svg fill="none" viewBox="0 0 24 24">
      <path d="M21.31 5.125 7.56 18.875l-4.87-4.869" stroke="currentColor" strokeWidth="2" />
    </svg>
  );
};
